import { render, staticRenderFns } from "./BuildingPromoter.vue?vue&type=template&id=64f3bb5a&scoped=true&"
import script from "./BuildingPromoter.vue?vue&type=script&lang=js&"
export * from "./BuildingPromoter.vue?vue&type=script&lang=js&"
import style0 from "./BuildingPromoter.vue?vue&type=style&index=0&id=64f3bb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3bb5a",
  null
  
)

export default component.exports